import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=46cef0cc&scoped=true"
import script from "./PartsList.vue?vue&type=script&lang=js"
export * from "./PartsList.vue?vue&type=script&lang=js"
import style0 from "./PartsList.vue?vue&type=style&index=0&id=46cef0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cef0cc",
  null
  
)

export default component.exports